import { useContext } from 'react'
import { GameContext, SetUpdateContext } from '../../App'
import { calculateDebtPrestige } from '../../../../shared/common/tasks/get_prestige'
import { formatBigInt, Style } from '../../common/format_large_number'
import useDebtCalculation from '../../hooks/useDebtCalculation'

export default function PrestigeWidget() {
	const gameContext = useContext(GameContext)
	const setUpdate = useContext(SetUpdateContext)
	if (!gameContext) throw new Error('No GameContext')
	if (!setUpdate) throw new Error('No SetUpdateContext')

	const { debt } = useDebtCalculation()

	const prestigeInfo = calculateDebtPrestige(
		BigInt(gameContext.money) -
			debt +
			BigInt(gameContext.totalDebtAccumulated ?? 0)
	)

	return (
		<div className="rounded-2xl border border-purple-800 bg-purple-950/80 p-6 backdrop-blur-sm transition-all hover:border-purple-700 hover:bg-purple-900/80">
			<div className="mb-4 flex items-center justify-between">
				<h2 className="text-2xl font-bold text-purple-100">Prestige</h2>
				<span className="rounded-full bg-purple-700 px-3 py-1 text-sm text-purple-100">
					Level {gameContext.currentPrestigeLevels ?? 0}
				</span>
			</div>
			<p className="mb-2 text-purple-200">
				Prestige to reset your progress and gain permanent bonuses. Every
				prestige level gives you 100% more debt per second.
			</p>
			<p className="mb-6 text-purple-200">
				{prestigeInfo.currentLevel === 0n
					? "You haven't achieved any new prestige levels in this ascension yet."
					: prestigeInfo.currentLevel <=
						  BigInt(gameContext.currentPrestigeLevels ?? 0)
						? `You need to reach a higher level than your current one to ascend. In this ascension, you've only gained ${prestigeInfo.currentLevel} so far, which is ${
								prestigeInfo.currentLevel ===
								BigInt(gameContext.currentPrestigeLevels ?? 0)
									? 'equal to'
									: 'lower than'
							} your current level.`
						: `If you prestige now, you'll gain ${prestigeInfo.currentLevel - BigInt(gameContext.currentPrestigeLevels ?? 0)} new prestige level${prestigeInfo.currentLevel === 1n ? '' : 's'}.`}
			</p>
			<div className="mb-4 flex items-center justify-between text-sm text-purple-200">
				<span>Next bonus at:</span>
				<span>
					{formatBigInt(prestigeInfo.debtForNextLevel, Style.Short)} debt
				</span>
			</div>
			<div className="relative mb-6 h-2 overflow-hidden rounded-full bg-purple-800">
				<div
					className="h-full bg-purple-400"
					style={{
						width: `${Math.min(
							(Number(prestigeInfo.additionalDebtNeeded) /
								Number(prestigeInfo.debtForNextLevel)) *
								100,
							100
						)}%`
					}}
				/>
			</div>
			<button
				className="w-full rounded-lg bg-purple-600 py-3 text-center font-semibold text-purple-100 transition-colors hover:bg-purple-500 disabled:cursor-not-allowed disabled:opacity-50"
				onClick={() =>
					setUpdate({
						id: crypto.randomUUID(),
						type: 'prestige'
					})
				}
				disabled={
					prestigeInfo.currentLevel <=
					BigInt(gameContext.currentPrestigeLevels ?? 0)
				}
			>
				Prestige Now
			</button>
		</div>
	)
}
